import React from "react";
import { View, StyleSheet } from "react-native";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import BaseController from "../../common/base/BaseController";
import NtListHeader from "../../components/NtListHeader";
import NtListEmpty from "../../components/NtListEmpty";
import NtPageSection from "../../components/NtPageSection";
import NtPagination from "../../components/NtPagination";
import NtSearchBar from "../../components/NtSearchBar";
import {
  asyncStorageSetData,
  parseDisplayDate,
  showToast,
} from "../../common/utils/ControllerUtils";
import Logger from "../../common/utils/Logger";
import { fetchVoicemails, deleteVoicemailMessage } from "../../api/voicemail";
import settings from "../../config/settings";
import voicemailmessagecsvcolumndata from "../data/voicemailmessagecsvcolumndata";
import moment from "moment-timezone";
import NtVoicemailMessageItem from "../components/NtVoicemailMessageItem";

class VoicemailMessageController extends BaseController {
  state = {
    ...super.state,
    loading: false,
    data: [],
    totalItems: 0,
    searchText: "",
    searchFilter: null,
    page: 1,
  };

  column_location = "@voicemailmessage_column_storage";

  componentDidMount() {
    this.handleDefaultColumnsFetch(
      this.column_location,
      voicemailmessagecsvcolumndata.filter((each) => each.default === true),
    );
    this.handleDataFetch();
  }


  handleDataFetch = async () => {
    this.setState({ loading: true });
    const response = await fetchVoicemails(
      this.context.user?.domain,
      this.props.route?.params?.extension,
      this.state.page,
      settings.pageSizeLoad,
      this.state.searchText,
      this.state.searchFilter,
    );
    Logger("VoicemailMessages fetch response", response);
    if (response.ok) {
      this.setState({
        data: response.data?.data || [],
        totalItems: response.data?.total || 0,
      });
    }
    this.setState({ loading: false });
  };

  handleExportFetch = async () => {
    const response = await fetchVoicemails(
      this.context.user?.domain,
      this.props.route?.params?.extension,
      1, 100000,
      this.state.searchText,
      this.state.searchFilter,
    );
    return response.ok ? response.data?.data || [] : [];
  };

  handleExportDataParce = (item, column) => {
    if (column === "message_length") return `${item[column]}s`;
    if (column === "created_epoch") {
      const date = moment.unix(item[column]).toDate();
      return `"${parseDisplayDate(date)}"`;
    }
    if (column === "player") return "";
    return item[column];
  };

  handleSearch = (text) => {
    this.setState({ searchText: text, page: 1 }, () => this.handleDataFetch());
  };

  handlePageChange = (nextPage) => {
    this.setState({ page: nextPage }, () => this.handleDataFetch());
  };

  handleDelete = async (item) => {
    const response = await deleteVoicemailMessage(
      this.context.user?.domain,
      this.props.route?.params?.extension,
      item.voicemail_message_uuid,
    );
    Logger("Voicemail message delete response", response);
    if (response.ok) {
      this.handleDataFetch();
      showToast("Success", "Successfully deleted the message");
    }
  };

  renderRow = (item) => (
    <NtVoicemailMessageItem
      key={item.voicemail_message_uuid}
      item={item}
      columns={this.state.columns}
      extension={this.props.route?.params?.extension}
      canEdit={this.handlePermissionCheck(settings.permissionTypeEdit)}
      onDelete={this.handleDelete}
    />
  );

  render() {
    const extension = this.props.route?.params?.extension;
    const subtitle = `Ext ${extension || "—"} · ${this.state.totalItems || 0} message${this.state.totalItems === 1 ? "" : "s"}`;
    const searchBar = (
      <NtSearchBar value={this.state.searchText} onChangeText={this.handleSearch} />
    );

    return (
      <NtRootPageContainer
        pageTitle="Voicemail Messages"
        pageSubtitle={subtitle}
        showBackButton
      >
        <NtPageSection
          search={searchBar}
          footer={
            <NtPagination
              page={this.state.page}
              pageSize={settings.pageSizeLoad}
              total={this.state.totalItems}
              onChange={this.handlePageChange}
            />
          }
        >
          <View style={styles.tableWrap}>
            <NtListHeader
              visible={this.state.data?.length > 0}
              columns={voicemailmessagecsvcolumndata}
              selectedColumns={this.state.columns}
              onColumnUpdate={(updated) => {
                asyncStorageSetData(this.column_location, updated);
                this.setState({ columns: updated });
              }}
              exportFileName="voicemail-messages"
              exportDataParser={this.handleExportDataParce}
              exportFetchDataAsync={this.handleExportFetch}
            />
            <NtListEmpty visible={this.state.data?.length === 0} />
            {this.state.data?.map(this.renderRow)}
          </View>
        </NtPageSection>
      </NtRootPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  tableWrap: { paddingHorizontal: 14, paddingVertical: 4 },
});

export default VoicemailMessageController;
